/**
 * Same as `useAllowedFeatureState` but this returns a boolean. Prioritize using this to avoid confusion with
 * `useAllowedFeatureState` since some places were using it and believing it was returning a boolean, producing wrong results.
 */

import useAllowedFeatureState, {
	ALLOWED_STATES,
} from '@apps/www/src/www/hooks/useAllowedFeatureState';
import AllowedFeature from '@pkgs/shared/enums/AllowedFeature';

export default function useAllowedFeature(allowedFeature: ValueOf<typeof AllowedFeature>): boolean {
	return useAllowedFeatureState(allowedFeature) === ALLOWED_STATES.ALLOWED;
}
